import { firestoreAction } from 'vuexfire'
import { Module, VuexModule, Action, getModule } from 'vuex-module-decorators'
import firebase, { firestore, Timestamp } from '../firebase'
import { UserStoreMod } from './user-store'
import store from './'

export interface VendorEvent {
  id?: string;
  title: string;
  location: string;
  vendorId?: string;
  createdDate?: firebase.firestore.Timestamp;
  createdBy?: string;
  modifiedDate?: firebase.firestore.Timestamp;
  modifiedBy?: string;
  orderStart?: firebase.firestore.Timestamp;
  orderEnd?: firebase.firestore.Timestamp;
  pickupStart?: firebase.firestore.Timestamp;
  pickupEnd?: firebase.firestore.Timestamp;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  menu: Array<any>;
}

export interface FirestoreState {
  events: Array<VendorEvent>;
}

@Module({ dynamic: true, store, name: 'events' })
class EventStore extends VuexModule implements FirestoreState {
  events: Array<VendorEvent> = []

  @Action
  async addEvent (newEvent: VendorEvent) {
    const event: VendorEvent = {
      ...newEvent,
      vendorId: UserStoreMod.vendorId,
      createdDate: Timestamp.now(),
      modifiedDate: Timestamp.now(),
      createdBy: UserStoreMod.user.id,
      modifiedBy: UserStoreMod.user.id
    }
    await firestore.collection('events').add(event)
  }

  @Action
  bindEvents () {
    return (firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef(
        'events',
        firestore.collection('events')
          .where('vendorId', '==', UserStoreMod.vendorId),
        { maxRefDepth: 0 }
      )
    }) as Function)(this.context)
  }

  @Action
  async saveEvent (updatedEvent: VendorEvent) {
    // console.log('event-store saveEvent')
    const event: VendorEvent = {
      ...updatedEvent,
      modifiedDate: Timestamp.now(),
      modifiedBy: UserStoreMod.user.id
    }

    // make food into references
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event.menu = event.menu.map((f: any) => firestore.collection('food').doc(f))

    await firestore.collection('events').doc(updatedEvent.id).update(event)
  }
}

export const eventStore = getModule(EventStore)
